// dawn-theme/assets/drop-currency.js
// Conversión SOLO-VISUAL de precios. El checkout sigue en la moneda base.
// Copia de las funciones puras de pipeline/lib/money-format.js (mantener en sync).
(function () {
  var API_BASE = 'https://api.sololander.com';
  var cfg = window.__dropCurrency || {};
  // QA #6 (moneda local): ?dc_country=MX fuerza el país de la conversión visual
  // sin VPN. Solo afecta esta visita en este navegador; Shopify y el checkout no
  // lo ven (la conversión ya era solo-visual).
  try {
    var qcc = new URLSearchParams(location.search).get('dc_country');
    if (qcc) cfg.country = qcc;
  } catch (e) {}
  if (!cfg.shop || !cfg.country) return;
  // Si Shopify ya hace multimoneda nativa, no tocar nada.
  try {
    if (window.Shopify && Shopify.currency && Shopify.currency.enabled === true) return;
  } catch (e) {}

  var DECIMALS = { USD:2,EUR:2,MXN:2,BRL:2,ARS:2,PEN:2,GBP:2,CAD:2,AUD:2, CLP:0,JPY:0,COP:0,PYG:0 };
  var C2C = { CL:'CLP',US:'USD',MX:'MXN',CO:'COP',PE:'PEN',AR:'ARS',BR:'BRL',ES:'EUR',JP:'JPY',GB:'GBP',CA:'CAD',AU:'AUD',PY:'PYG' };
  function dec(c){ var d=DECIMALS[(c||'').toUpperCase()]; return d==null?2:d; }
  function parsePrice(text, decimals){ var s=String(text||'').replace(/[^0-9.,]/g,''); if(!s) return NaN;
    if(decimals===0) return parseInt(s.replace(/[.,]/g,''),10);
    var i=Math.max(s.lastIndexOf('.'),s.lastIndexOf(',')); if(i===-1) return parseFloat(s);
    var ip=s.slice(0,i).replace(/[.,]/g,''), dp=s.slice(i+1).replace(/[.,]/g,'');
    if(dp.length!==2) return parseInt(ip+dp,10); return parseFloat(ip+'.'+dp); }
  function round(n, c, style){ if(!(n>0)) return 0; var s=style==='auto'?'9':style;
    if(dec(c)===2){ if(s==='0') return Math.ceil(n); var cents=s==='5'?0.95:s==='97'?0.97:0.99; var r=Math.floor(n)+cents; if(r<n) r=Math.floor(n)+1+cents; return Math.round(r*100)/100; }
    var step=1000; if(s==='0') return Math.ceil(n/step)*step; var end=s==='5'?950:s==='97'?970:990; var r=Math.floor(n/step)*step+end; if(r<n) r+=step; return r; }
  function fmt(n, c){ var d=dec(c); try { return new Intl.NumberFormat(undefined,{style:'currency',currency:c,minimumFractionDigits:d,maximumFractionDigits:d,useGrouping:'always'}).format(n); } catch(e){ return n + ' ' + c; } }

  // store_id manda; ?shop= queda de respaldo. Varias cuentas pueden tener conectada la MISMA
  // tienda de Shopify a propósito, así que por dominio el backend tenía que adivinar cuál de
  // ellas: le podía devolver al comprador la moneda base, el redondeo y el texto legal de otra.
  // El respaldo importa: un tema que todavía no recibió el bloque nuevo sigue funcionando.
  var url = cfg.store_id
    ? API_BASE + '/public/store-config?store_id=' + encodeURIComponent(cfg.store_id)
    : API_BASE + '/public/store-config?shop=' + encodeURIComponent(cfg.shop);
  fetch(url)
    .then(function(r){ return r.json(); })
    .then(function(conf){
      if (!conf || !conf.currency_display) return;
      var base = conf.base_currency || 'USD';
      var target = C2C[(cfg.country||'').toUpperCase()];
      if (!target || target === base) return;
      var rate = conf.rates && conf.rates[target];
      if (!rate) return;
      // Precios a convertir: el bloque nativo de Dawn (.price__container) Y los del
      // selector de bundles (la oferta vive ahí: precio, tachado, ahorro) + el sticky del tema.
      var SELECTORS = '.price__container .price-item, .sp-bsel__price, .sp-bsel__compare, .sp-bsel__save, .sp-sticky-atc__price';

      // __dcLast = el último texto que ESTE asset escribió. Si el texto actual lo escribimos
      // nosotros → ya está convertido, no tocar. Si difiere (carga inicial o Dawn re-renderizó
      // el precio al cambiar de variante/pack) → es moneda base, (re)convertir desde el valor
      // visible. __dcVal = el NÚMERO convertido, para derivar montos sin re-parsear el texto.

      // Registro GLOBAL de textos que este asset escribió en CUALQUIER nodo. El guard
      // __dcLast es por-nodo y no cubre el copy-paste entre nodos: el sticky del tema
      // (syncInfo) copia al #sp-sticky-price el texto YA convertido del .price-item
      // nativo; para el nodo destino ese texto es "nuevo" y sin este registro se
      // re-parseaba como moneda base y se le aplicaba el rate OTRA VEZ (revisión 07-21;
      // con target de 0 decimales, $13.990 → ~$13 millones).
      var produced = Object.create(null);

      // Conversión "propia" de un elemento: redondeo configurado (.97, etc.), como siempre.
      // Devuelve el valor convertido (número) o null si no había nada convertible.
      function convertOwn(el){
        if (!el) return null;
        var cur = el.textContent;
        if (el.__dcLast != null && cur === el.__dcLast) return el.__dcVal != null ? el.__dcVal : null;
        if (produced[cur]) { el.__dcLast = cur; return el.__dcVal != null ? el.__dcVal : null; }
        var val = parsePrice(cur, dec(base)); if(!(val>0)) return null;
        var conv = round(val * rate, target, conf.rounding_style || 'auto');
        var out = fmt(conv, target);
        el.textContent = out; el.__dcLast = out; el.__dcVal = conv;
        produced[out] = 1;
        return conv;
      }

      // Montos DERIVADOS dentro de una card (ahorro): aritmética sobre los valores YA
      // convertidos + fmt(), SIN round() de estilo. Redondear cada cifra por separado hacía
      // que el chip no cuadrara con la resta visible de la misma card (QA 07-21:
      // 14,97 − 13,97 = 1,00 pero el chip decía "Ahorras US$1,97").
      function writeDerived(el, n){
        if (!el || !(n > 0)) return;
        var out = fmt(n, target);
        if (el.textContent !== out) el.textContent = out;
        el.__dcLast = out; el.__dcVal = n;
        produced[out] = 1;
      }

      // Floor a los decimales de la moneda — sin usar tras Task 3 (retiro del precio-por-unidad).
      // Mantiene la firma por si se reutiliza en el futuro.
      function floorTo(n, c){ var f = Math.pow(10, dec(c)); return Math.floor(n * f + 1e-9) / f; }

      function convertAll(){
        // 1) Cards del selector de bundles: precio y tachado se convierten con el redondeo
        //    configurado; ahorro se DERIVA de esos dos para que cada card cierre sola.
        document.querySelectorAll('.sp-bsel__row').forEach(function(row){
          var priceConv   = convertOwn(row.querySelector('.sp-bsel__price'));
          var compareConv = convertOwn(row.querySelector('.sp-bsel__compare'));
          // P17 (19-08): el chip de ahorro se movió de .sp-bsel__save-amount a .sp-bsel__unit
          // (mismo <span class="sp-bsel__save"> anidado, nueva ubicación — ver sp-bundle-select.liquid).
          // El precio-por-unidad ya no se renderiza en ningún camino del Liquid, así que la
          // derivación priceConv/units se retira: no queda ningún nodo al que aplicarla.
          // 12-10: el monto de ahorro también puede vivir DENTRO del chip premium (ajuste
          // savings_display = amount|both → <span class="sp-bsel__save"> en .sp-bsel__discount).
          // Se convierten todos los montos de ahorro de la card, cada uno con su contenedor.
          row.querySelectorAll('.sp-bsel__unit .sp-bsel__save, .sp-bsel__discount .sp-bsel__save').forEach(function(saveEl){
            if (priceConv != null && compareConv != null) {
              var saveWrap = saveEl.closest('.sp-bsel__unit, .sp-bsel__discount');
              // Ahorro = tachado convertido − precio convertido (resta exacta; fmt redondea
              // el ruido de coma flotante al mostrar).
              var diff = compareConv - priceConv;
              if (diff > 0) {
                if (saveWrap) saveWrap.style.display = '';
                writeDerived(saveEl, diff);
              } else if (saveWrap) {
                // El redondeo de estilo puede colapsar tachado y precio al MISMO valor
                // (revisión 07-21: base 13.20/13.60 con '99' → ambos 13.99). Un "Ahorras"
                // > 0 junto a dos precios idénticos es mentira visible → chip fuera.
                saveWrap.style.display = 'none';
              }
            } else {
              // Sin par precio/tachado convertido no hay resta que derivar → comportamiento
              // de siempre (conversión independiente); mejor eso que dejar la cifra en base.
              convertOwn(saveEl);
            }
          });
          // Precio tachado dentro de un regalo (Charly 08-09: pidió que también refleje
          // moneda local "como lo hacen los precios"). El campo completo
          // (.sp-bsel__extra-tag/.sp-bsel__extra-text) es texto LIBRE del merchant — puede
          // mezclar palabras con el precio, ej. "<s>$34.95</s> GRATIS" — así que tratarlo
          // como .sp-bsel__price (todo el textContent es un único número) destruiría el
          // resto. Se convierte SOLO el <s> interno: el propio marcado de "tachado" ya
          // delimita qué porción es numérica, y convertOwn() no toca nada fuera de ese nodo.
          // Si lo que hay adentro no parsea como precio (el merchant tachó una palabra),
          // convertOwn() ya degrada a no-op (ver `if(!(val>0)) return null`).
          row.querySelectorAll('.sp-bsel__extra-tag s, .sp-bsel__extra-text s').forEach(function(s){
            convertOwn(s);
          });
        });
        // 2) Resto de la página (precio nativo de Dawn, sticky): conversión de siempre.
        //    Lo que vive dentro de una card ya se procesó arriba → se salta.
        document.querySelectorAll(SELECTORS).forEach(function(el){
          if (el.closest && el.closest('.sp-bsel__row')) return;
          convertOwn(el);
        });
      }
      // Debounce: el editor de temas muta el DOM sin parar (drag, resize, live preview).
      // Sin esto, cada mutación dispara convertAll() de inmediato -> cascada de re-renders.
      // Se espera un período de calma de DEBOUNCE_MS antes de (re)convertir.
      var DEBOUNCE_MS = 200;
      var debounceTimer = null;
      function schedule(){
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function(){ debounceTimer = null; convertAll(); }, DEBOUNCE_MS);
      }
      convertAll();
      new MutationObserver(schedule).observe(document.body, { childList:true, subtree:true });
      if (conf.disclaimer_enabled !== false && !document.querySelector('.dc-disclaimer')) {
        var txt = (conf.disclaimer_text || '').replace(/\{moneda\}/g, target).replace(/\{base\}/g, base);
        if (txt) {
          var d = document.createElement('div');
          d.className = 'dc-disclaimer';
          d.style.cssText = 'font-size:1.2rem;line-height:1.4;opacity:.75;text-align:center;padding:.8rem 1.6rem';
          d.textContent = txt;
          // Ancla: el bundle es lo que el visitante ve (el .price__container nativo suele estar
          // oculto en estas páginas). Caer al precio nativo o al form si no hay bundle.
          var anchor = document.querySelector('.sp-bsel') || document.querySelector('.price__container') || document.querySelector('.product-form');
          if (anchor) anchor.insertAdjacentElement('afterend', d);
        }
      }
    })
    .catch(function(){ /* degrada: deja base */ });
})();
